import { optimizedGantt } from "@planzone/dto";

const initialState = optimizedGantt;

export { initialState };
